import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { PageHeaderActions } from './page-header-actions';

@Component({
  selector: 'fr8bot-ui-page-header',
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class PageHeaderUIComponent {
  protected readonly actions = inject(PageHeaderActions, { optional: true });

  constructor() {
    const detach = this.actions?.attachHeader();

    if (detach) {
      inject(DestroyRef).onDestroy(detach);
    }
  }
}
